import parse from 'html-react-parser';
import { Card, Grid, Typography } from '@mui/material';
import { GET_ABOUT_PAGE } from 'src/apiService/apiDeclaration';
import AboutPageForm from 'src/components/form/about/aboutPageForm';
import CustomLoader from 'src/components/loader/loader';
import PageHeader from 'src/components/pageHeader/PageHeader';
import TabTitle from 'src/components/tabTitle/tabTitle';
import useApiGetter from 'src/hooks/useApiGetter';
import { ICONS } from 'src/assets/library';
import { useModal } from 'src/hooks/useModal';
import AboutItemForm from 'src/components/form/about/aboutItemForm';

const AboutPage = () => {
  const { data, refresh } = useApiGetter(GET_ABOUT_PAGE);
  const { handleModalClose, setDialogData } = useModal();

  const onSuccess = () => {
    handleModalClose();
    refresh();
  };
  return (
    <Grid container spacing={2}>
      <TabTitle title={'About'} />
      <Grid item xs={12}>
        <PageHeader pageTitle={'About'} />
      </Grid>
      {!data ? (
        <Grid item xs={12}>
          <Card>
            <CustomLoader />
          </Card>
        </Grid>
      ) : (
        <>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>{<AboutPageForm data={data} />}</Card>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <Typography variant="h6" mb={1}>
                Middle Section
              </Typography>
              {data.middle.map((item, index) => (
                <Grid display={'flex'} gap={1} key={index} py={0.5}>
                  <Typography>{parse(item.head.en)}</Typography>
                  <Grid
                    onClick={() =>
                      setDialogData({
                        showModal: true,
                        title: 'Update ',
                        child: <AboutItemForm data={item} parent={data._id} onSuccess={onSuccess} />,
                      })
                    }
                    sx={{ cursor: 'pointer' }}
                  >
                    {ICONS.edit}
                  </Grid>
                </Grid>
              ))}
            </Card>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AboutPage;
